import { createContext, useState } from "react";
import api from "../services/api";
import Cookies from 'js-cookie'
import { getPanelDetail } from '../services/getPanelDetail'
import i18n from '../i18n'

const LANG_MAP = { 0: 'en', 1: 'es', 2: 'pt', 3: 'it' };

const applyLanguage = (langId) => {
    const locale = LANG_MAP[langId] ?? 'it';
    i18n.changeLanguage(locale);
    localStorage.setItem('admind_lang', locale);
};

const SESSION_KEY = 'admind_session';

const getStoredSession = () => {
    try {
        const raw = localStorage.getItem(SESSION_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const saveStoredSession = (session) => {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

const clearStoredSession = () => {
    localStorage.removeItem(SESSION_KEY);
    Cookies.remove("airton@data");
};

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const storedSession = getStoredSession();

    if (storedSession?.token) {
        api.defaults.headers.common.Authorization = `Bearer ${storedSession.token}`;
    }

    const [user, setUser] = useState(storedSession?.user || null);
    const [historic, setHistoric] = useState(null);
    
    const [upgradePanel, setUpgradePanel] = useState({
        title: 'This is a PRO feature.',
        text: 'Integrate your Digital Channels and unlock the full potential of our platform by upgrading to the PRO plan and enjoy this exclusive feature!',
        textButton: 'Upgrade your plan',
        show: false,
        data: null,
        view: false,
        navegate:'/pricing'
    });

    const [updatePanel, setUpdatePanel] = useState(false);
    const [language, setLanguage] = useState(storedSession?.user?.language);
    const [integration, setIntegration] = useState({open:false, profile:null, publications:[], image:''});
    const [signed, setSigned] = useState(Boolean(storedSession?.token));

    const signIn = (register, remember) => {
        let token = register.token;
        api.defaults.headers.common.Authorization = `Bearer ${register.token}`;

        let user = register.user;

        let data = {
            user: user,
            token: token,
            refresh: register.refresh || null,
            remember: remember,
        };

        saveStoredSession(data);
        setUser(user);
        setLanguage(user.language);
        applyLanguage(user.language);
        setSigned(true);
        return "SUCCESS";
    };

    const signOut = () => {
        api.defaults.headers.common.Authorization = `Bearer `;

        clearStoredSession();
        setUser(null);
        setSigned(false);
        return "SUCCESS";
    };

    const _setUser = () => {
        getPanelDetail()
            .then(async (json) => {
                if (json?.type === "error") {
                    if (json.data.code === "token_not_valid") {
                        signOut();
                    }
                }
                else {
                    const session = getStoredSession()
                    let data = {
                        ...session,
                        user: json.data
                    };
                    saveStoredSession(data);
                    setUser(json.data);
                    setLanguage(json.data.language);
                    applyLanguage(json.data.language);
                }
                
            })
            .catch((error) => {
                return "ERROR";
            });
        return "SUCCESS";
    };

    
    return (
        <AuthContext.Provider
            value={
                { 
                    user, 
                    signed: signed, 
                    signIn, 
                    signOut, 
                    setUser:_setUser, 
                    language:{ set: setLanguage, value: language}, 
                    historic:{ set: setHistoric, value: historic},
                    updatePanel:{ set: setUpdatePanel, value: updatePanel},
                    integration:{ set: setIntegration, value: integration},
                    upgradePanel:{ set: setUpgradePanel, value: upgradePanel},
                }}
        >
            {children}
        </AuthContext.Provider>
    );
};
